<div class="mfa-req-wrapper">
  <div class="mfa-req-card">

    <!-- Alert banner -->
    <div class="req-alert">
      <mat-icon>shield</mat-icon>
      <div>
        <strong>Autenticação em dois fatores obrigatória</strong>
        <span>Por segurança, esta plataforma exige MFA ativo em todas as contas.</span>
      </div>
    </div>

    <!-- Step: Intro -->
    <ng-container *ngIf="step === 'intro'">
      <div class="req-header">
        <div class="req-icon-wrap">
          <mat-icon>lock</mat-icon>
        </div>
        <h2>Configure o MFA agora</h2>
        <p>Você precisa ativar a autenticação em dois fatores antes de continuar. O processo leva menos de 1 minuto.</p>
      </div>

      <div class="req-steps-preview">
        <div class="preview-step">
          <span class="step-num">1</span>
          <span>Escaneie o QR Code com Google Authenticator, Authy ou similar</span>
        </div>
        <div class="preview-step">
          <span class="step-num">2</span>
          <span>Confirme com o código de 6 dígitos gerado pelo app</span>
        </div>
        <div class="preview-step">
          <span class="step-num">3</span>
          <span>Guarde seus códigos de recuperação em local seguro</span>
        </div>
      </div>

      <button mat-raised-button class="btn-primary full-width" (click)="startSetup()" [disabled]="loading">
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        <span *ngIf="!loading">
          <mat-icon style="margin-right:6px;vertical-align:middle">play_arrow</mat-icon>
          Começar configuração
        </span>
      </button>

      <button mat-button class="btn-cancel full-width" (click)="cancel()">
        <mat-icon>logout</mat-icon>
        Cancelar e sair
      </button>
    </ng-container>

    <!-- Step: QR Code -->
    <ng-container *ngIf="step === 'qr'">
      <div class="req-header">
        <h2>Escaneie o QR Code</h2>
        <p>Abra seu aplicativo autenticador (Google Authenticator, Authy, etc.) e escaneie o código abaixo.</p>
      </div>

      <div class="qr-wrapper">
        <img [src]="qrCode" alt="QR Code MFA" />
      </div>

      <div class="secret-display">
        <label>Chave manual</label>
        <code>{{ secret }}</code>
      </div>

      <button mat-raised-button class="btn-primary full-width" (click)="nextStep()">
        Já escaneei — continuar
        <mat-icon style="margin-left:6px">arrow_forward</mat-icon>
      </button>
    </ng-container>

    <!-- Step: Verify -->
    <ng-container *ngIf="step === 'verify'">
      <div class="req-header">
        <h2>Confirme o código</h2>
        <p>Digite o código de 6 dígitos exibido no seu aplicativo autenticador.</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="verifyCode()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Código de 6 dígitos</mat-label>
          <input matInput formControlName="token" maxlength="6" autocomplete="one-time-code" autofocus
            inputmode="numeric" placeholder="000000" />
          <mat-icon matPrefix>pin</mat-icon>
        </mat-form-field>

        <button mat-raised-button class="btn-primary full-width" type="submit" [disabled]="form.invalid || loading">
          <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
          <span *ngIf="!loading">Ativar MFA</span>
        </button>
      </form>
    </ng-container>

    <!-- Step: Recovery codes -->
    <ng-container *ngIf="step === 'codes'">
      <div class="req-header">
        <div class="req-icon-wrap success">
          <mat-icon>check_circle</mat-icon>
        </div>
        <h2>MFA ativado!</h2>
        <p>Guarde estes códigos de recuperação em local seguro. Eles são usados caso você perca acesso ao autenticador.</p>
      </div>

      <div class="warning-banner">
        <mat-icon>warning</mat-icon>
        <span>Cada código pode ser usado uma única vez. Não compartilhe com ninguém.</span>
      </div>

      <div class="codes-grid">
        <code *ngFor="let code of recoveryCodes" class="recovery-code">{{ code }}</code>
      </div>

      <div class="codes-actions">
        <button mat-stroked-button class="full-width" (click)="copyCodes()">
          <mat-icon>content_copy</mat-icon> Copiar todos os códigos
        </button>
      </div>

      <button mat-raised-button class="btn-primary full-width" (click)="finish()" style="margin-top:12px">
        Ir para o Dashboard
        <mat-icon style="margin-left:6px">arrow_forward</mat-icon>
      </button>
    </ng-container>

  </div>
</div>
